module.exports = __webpack_public_path__ + "img/Patch6.6ccdd0dd.webp";